let React = require('react');
// -------------------------------------------------------

let Utils      = require('../../server/utils/utils-common');
let UtilsFront = require('./utils-front');
if (UtilsFront && UtilsFront.default) UtilsFront = UtilsFront.default;

const merged = Object.assign({}, Utils, UtilsFront);

// require('utils').xxx      → merged.xxx       (link.jsx など)
// require('utils').default.xxx → merged.xxx    (login.jsx など)
merged.default = merged;

module.exports = merged;